import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface TopPerformersProps {
  topApps: { appId: string; credits: number; ops: number }[];
  topAccounts: { accountId: string; accountName: string; credits: number; ops: number }[];
}

const TopPerformers = ({ topApps, topAccounts }: TopPerformersProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>אפליקציות מובילות</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-right">אפליקציה</TableHead>
                <TableHead className="text-right">קרדיטים</TableHead>
                <TableHead className="text-right">פעולות</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {topApps.map((app) => (
                <TableRow key={app.appId}>
                  <TableCell className="font-medium">{app.appId}</TableCell>
                  <TableCell>{app.credits.toLocaleString()}</TableCell>
                  <TableCell>{app.ops.toLocaleString()}</TableCell>
                </TableRow>
              ))}
              {topApps.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} className="text-center text-muted-foreground">
                    אין נתונים
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>חשבונות מובילים</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-right">שם חשבון</TableHead>
                <TableHead className="text-right">קרדיטים</TableHead>
                <TableHead className="text-right">פעולות</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {topAccounts.map((account) => (
                <TableRow key={account.accountId}>
                  <TableCell className="font-medium">
                    <div>{account.accountName}</div>
                    <div className="text-xs text-muted-foreground hidden lg:block">{account.accountId.substring(0, 8)}...</div>
                  </TableCell>
                  <TableCell>{account.credits.toLocaleString()}</TableCell>
                  <TableCell>{account.ops.toLocaleString()}</TableCell>
                </TableRow>
              ))}
              {topAccounts.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} className="text-center text-muted-foreground">
                    אין נתונים
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default TopPerformers;
